<template>
    <div class="video-view-wrapper">
        <div class="video-view-content">
            <!-- 注意：videoId前期加上embed才能正常加载， autoplay：1为自动播放-->
            <iframe
                class="iframe-modal-iframe"
                :src="'https://www.youtube.com/embed/' + videoId + '?autoplay=1'"
                frameborder="0"
                allowfullscreen
                height="100%"
            ></iframe>
            <Icon :width="36" :height="36" :iconUrl="iconUrl" class="video-view-close" @iconClick="close" />
        </div>
    </div>
</template>

<script>
import Icon from "@/views/zhiji/bComponents/icons/Icon";
import { loadScript } from "@/views/zhiji/js/common/util.js";

export default {
    name: "VideoViewModal",
    /**
     * data: {url: https://www.youtube.com/watch?v=VIDEO_ID}
     */
    props: ["data"],
    components: {
        Icon
    },
    data() {
        return {
            iconUrl: this.zhiji.staticPath() + "view_close.png",
            videoId: this.matchVideoId()
        };
    },
    methods: {
        close() {
            this.$emit("closeModal");
        },
        matchVideoId() {
            let matchVideoId = this.data.url.match(/v=([^&]+)/);
            return matchVideoId !== null ? (this.videoId = matchVideoId[1]) : "";
        }
    }
};
</script>

<style scoped lang="less">
.video-view-wrapper {
    width: 100%;
    height: 100%;
    background-color: rgba(18, 22, 37, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 1330px;
    min-height: 820px;
    .video-view-content {
        height: 50%;
        width: 50%;
        position: relative;
        .video-view-frame {
            width: 1280px;
            height: 720px;
        }
        .video-view-close {
            position: absolute;
            top: -50px;
            right: 0;
            z-index: 1;
        }
        .iframe-modal-iframe {
            height: 100%;
            width: 100%;
        }
    }
}
</style>
